import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class DigitalBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { digitalTopic, digitalTitle, digitalList0, digitalList1 },
        } = this.props;

        return (
            <div id="digitalNewsList" className={styles.digital_box}>
                <Chip id="50080" type="struct" title="数码栏标题" groupName="数码栏" content={digitalTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75107"
                    type="recommend"
                    title="数码栏头条"
                    groupName="数码栏"
                    content={digitalTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75108"
                    type="recommend"
                    title="数码栏新闻列表1"
                    groupName="数码栏"
                    content={digitalList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75109"
                    type="recommend"
                    title="数码栏头条2"
                    groupName="数码栏"
                    content={digitalList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(DigitalBox);
